import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UnidadOrgService {
  token: string = '';
  baseUrl = environment.apiEndpoint;

  constructor(private http: HttpClient) {
    this.token = environment.token;
  }

  private header(accessToken: string) {
    var headers = new HttpHeaders({
      'Content-Type': 'application/json',
      "Accept": "application/json",
      "Authorization": "Bearer " + accessToken
    });
    return headers;
  }

  getUnidadOrg(): Observable<any> {
    return this.http.get(this.baseUrl + 'parUnidadOrganizacionales', { headers: this.header(this.token) });
  }

  getUnidadOrgconDA(): Observable<any> {
    return this.http.get(this.baseUrl + 'parUnidadOrganizacionalesConDA', { headers: this.header(this.token) });
  }

  getUnidadOrgActivos(): Observable<any> {
    return this.http.get(this.baseUrl + 'getParUnidadOrganizacionalActivos', { headers: this.header(this.token) });
  }
  

  getUnidadOrgById(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'parUnidadOrganizacional/' + id, { headers: this.header(this.token) });
  }

  postUnidadOrg(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.post(this.baseUrl + 'parUnidadOrganizacional', bodyString, { headers: this.header(this.token) });
  }

  putUnidadOrg(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'parUnidadOrganizacional', bodyString, { headers: this.header(this.token) });
  }

  deleteUnidadOrg(id: number): Observable<any> {
    return this.http.delete(this.baseUrl + 'parUnidadOrganizacional/' + id, { headers: this.header(this.token) });
  }

  getUnidadEjecutora(): Observable<any> {
    return this.http.get(this.baseUrl + 'unidadesEjecutoras', { headers: this.header(this.token) });
  }

  getUnidadEjecutoraSigep(): Observable<any> {
    return this.http.get(this.baseUrl + 'unidadesEjecutorasSigep', { headers: this.header(this.token) });
  }


  
}
